import { render, staticRenderFns } from "./productBrochure.vue?vue&type=template&id=1e147972&scoped=true"
import script from "./productBrochure.vue?vue&type=script&lang=js"
export * from "./productBrochure.vue?vue&type=script&lang=js"
import style0 from "./productBrochure.vue?vue&type=style&index=0&id=1e147972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e147972",
  null
  
)

export default component.exports